import * as React from 'react'
import { SocialButtons } from '../../../../shared/buttons'
import styled from 'styled-components'

export type PropsType = {
  isConnected: boolean,
  linkAccountRequestInProgress: boolean,
  isLoading: boolean
}

export type DispatchPropsType = {
  toggleGoogleConnection: (isConnected: boolean) => void
}

export default function LinkGoogle (props: PropsType & DispatchPropsType): React.ReactNode {
  return (
    <SocialButtons
      onClick={(): void => {
        props.toggleGoogleConnection(props.isConnected)
      }}
      disabled={props.linkAccountRequestInProgress}
      isOutlineStyle={true}
    >
      <GoogleIcon alt='Sign in with Google' src='/images/google-icon-3x.png'/>
      {props.isConnected ? 'Disconnect' : 'Connect'}{props.isLoading && 'ing'} Google
    </SocialButtons>
  )
}

const GoogleIcon = styled.img<any>`
  width: 18px;
  height: 18px;
  margin-right: 8px;
`
